<template>
    <div class="questions-filter d-flex justify-content-between align-center">
        <h1>All Questions</h1>
        <div class="questions-filter-sort d-flex">
            <ask-question id="addQuestion" btnClass="mr-2" />
            <el-select v-model="value" clearable filterable placeholder="Select" size="large">
                <el-option label="newest" value="Newest" />
                <el-option label="old" value="Old" />
                <el-option label="best" value="Best" />
            </el-select>
        </div>
    </div>
</template>

<script>
import AskQuestion from '../pieces/AskQuestion.vue'
export default {
  components: { 
        AskQuestion 
    },
    name: 'QuestionsFilter',
    data() {
        return {
            value: ''
        }
    }
}
</script>